import { apiRequest, formUtils, incaAccessor, startPageUtils } from '@cancercentrum/inca';
import { useCallback, useContext } from 'react';
import { IncaContext } from '../components/ScopedIncaContext/IncaContext';
export const useGetValueDomainValues = ()=>{
    const inca = useContext(IncaContext);
    return useCallback(async (vdname, options)=>{
        if (inca?.type === 'form') {
            const data = await apiRequest(`/ValueDomains/ShortName/${vdname}`, {
                method: 'POST',
                json: {
                    errandId: inca.errand?.id || null,
                    rowId: options?.referringId || null,
                    documentId: inca.document?.id || null,
                    designedFormId: inca.form.designedFormId,
                    registerRecordId: inca.registerRecord?.id || null,
                    jsonFilter: options?.filters ? JSON.stringify(options.filters) : null,
                    parametersFilter: options?.parameters ? JSON.stringify(options.parameters) : null
                }
            });
            return data.filter((x)=>x.value).map((x)=>({
                    id: x.value,
                    text: x.displayText,
                    data: x.data
                }));
        }
        if (inca?.type === 'startpage') {
            const data = await apiRequest(`/StartPages/${inca.startPage.id}/ValueDomains/${encodeURIComponent(vdname)}`, {
                method: 'POST',
                json: options
            });
            return data.filter((x)=>x.value).map((x)=>({
                    id: x.value,
                    text: x.displayText,
                    data: x.data
                }));
        }
        if (inca?.type === 'custompage') {
            const data = await apiRequest(`/CustomPages/ShortName/${encodeURIComponent(inca.customPage.shortname)}/ValueDomains/${encodeURIComponent(vdname)}`, {
                method: 'POST',
                json: options
            });
            return data.filter((x)=>x.value).map((x)=>({
                    id: x.value,
                    text: x.displayText,
                    data: x.data
                }));
        }
        // @ts-ignore guard
        if (incaAccessor()?.form?.getValueDomainValues) {
            return formUtils.getValueDomainValues(vdname, options);
        }
        // @ts-ignore guard
        if (incaAccessor()?.services?.startPage?.getValueDomainValues) {
            return startPageUtils.getValueDomainValues(vdname, options);
        }
        throw new Error(`No scoped context was found. Fallback to global inca object wasn't found either.`);
    }, [
        inca
    ]);
};
